import css from 'styled-jsx/css';
import { warmGrays } from 'styles/colors/constants';
import { sansSerif, serif } from 'styles/css-constants';

export default css`
  .AmpTeaser {
    position: relative;
    display: flex;
    align-items: flex-start;
    box-sizing: border-box;
  }

  .AmpTeaser__body {
    flex: 0 0 50%;
    max-width: 50%;
    padding: 0 0 0 1rem;
    color: #000;
    box-sizing: inherit;
  }

  amp-timeago {
    font-family: ${sansSerif};
    font-size: 0.8rem;
    color: ${warmGrays[9]};
  }

  .AmpTeaser--default .AmpTeaser__headline {
    margin: 0 0 0.5rem 0;
    font-size: 1.2rem;
    line-height: 1.35em;
  }

  .AmpTeaser--default .AmpTeaser__picture {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .AmpTeaser--recipeRoundup {
    display: block;
    margin-bottom: 0.5rem;
  }

  .AmpTeaser--recipeRoundup .AmpTeaser__body {
    margin: auto;
    padding: 0;
    max-width: 100%;
    text-align: left;
  }

  .AmpTeaser--recipeRoundup .AmpTeaser__cta {
    display: inline-block;
    font-family: ${sansSerif};
    text-align: center;
  }

  .AmpTeaser--recipeRoundup .AmpTeaser__cta span {
    display: block;
    border: none;
    background-color: #fcd110;
    padding: 0.5rem 1.25rem;
    color: #321917;
    font-size: 14.22px;
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }}

  .AmpTeaser--recipeRoundup .AmpTeaser__dek {
    margin-bottom: 1rem;
    display: block;
    color: #000;
    font-family: ${serif};
    font-size: 18px;
    line-height: 1.45;
  }

  .AmpTeaser--recipeRoundup .AmpTeaser__headline {
    margin: 0 0 0.5rem;
    font-family: ${serif};
    font-size: 20.25px;
    line-height: 1.35em;
  }

  .AmpTeaser--recipeRoundup .AmpTeaser__picture {
    margin-bottom: 1rem;
  }
`;
